/**
 * Animated hourglass SVG — used in SafeView empty state while catalog loads
 * or as the "waiting for your first scores" illustration.
 * Pure SVG + SMIL animations, no external dependencies.
 */
export function HourglassSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 84"
      width="72"
      height="72"
      aria-hidden="true"
    >
      <defs>
        {/* Clip the sand to the top chamber shape */}
        <clipPath id="safe-hg-top">
          <polygon points="4,8 60,8 34,41 30,41" />
        </clipPath>
        {/* Clip the sand to the bottom chamber shape */}
        <clipPath id="safe-hg-bot">
          <polygon points="30,43 34,43 60,76 4,76" />
        </clipPath>
      </defs>

      {/* ── Frame ─────────────────────────────────────────────────────────── */}
      {/* Top cap */}
      <rect x="2" y="1" width="60" height="7" rx="3.5" fill="#342F82" />
      {/* Bottom cap */}
      <rect x="2" y="76" width="60" height="7" rx="3.5" fill="#342F82" />
      {/* Glass walls — top chamber */}
      <line x1="4"  y1="8"  x2="30" y2="41" stroke="#342F82" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="60" y1="8"  x2="34" y2="41" stroke="#342F82" strokeWidth="2.5" strokeLinecap="round" />
      {/* Glass walls — bottom chamber */}
      <line x1="30" y1="43" x2="4"  y2="76" stroke="#342F82" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="34" y1="43" x2="60" y2="76" stroke="#342F82" strokeWidth="2.5" strokeLinecap="round" />

      {/* ── Top sand — drains over 3 s then resets ────────────────────────── */}
      <g clipPath="url(#safe-hg-top)">
        <polygon fill="#F3C300" opacity="0.95">
          <animate
            attributeName="points"
            values="
              5,9 59,9 34,41 30,41;
              19,27 45,27 34,41 30,41;
              30.5,40.5 33.5,40.5 34,41 30,41;
              30.5,40.5 33.5,40.5 34,41 30,41;
              5,9 59,9 34,41 30,41
            "
            keyTimes="0; 0.62; 0.76; 0.88; 1"
            dur="3s"
            repeatCount="indefinite"
          />
        </polygon>
      </g>

      {/* ── Sand stream at the pinch — pulses to simulate flow ────────────── */}
      <rect x="30.5" y="40" width="3" height="6" rx="1.5" fill="#F08521">
        <animate
          attributeName="opacity"
          values="1; 0.25; 1"
          dur="0.45s"
          repeatCount="indefinite"
        />
      </rect>

      {/* ── Falling grains — 3 circles staggered every 0.3 s ─────────────── */}
      <circle cx="32" cy="44" r="1.8" fill="#F3C300" opacity="0">
        <animate attributeName="cy"      values="44;69"              dur="0.9s" begin="0s"   repeatCount="indefinite" />
        <animate attributeName="opacity" values="0;1;1;0" keyTimes="0;0.05;0.85;1" dur="0.9s" begin="0s"   repeatCount="indefinite" />
      </circle>
      <circle cx="32" cy="44" r="1.4" fill="#F08521" opacity="0">
        <animate attributeName="cy"      values="44;69"              dur="0.9s" begin="0.3s" repeatCount="indefinite" />
        <animate attributeName="opacity" values="0;1;1;0" keyTimes="0;0.05;0.85;1" dur="0.9s" begin="0.3s" repeatCount="indefinite" />
      </circle>
      <circle cx="32" cy="44" r="1.2" fill="#F3C300" opacity="0">
        <animate attributeName="cy"      values="44;69"              dur="0.9s" begin="0.6s" repeatCount="indefinite" />
        <animate attributeName="opacity" values="0;1;1;0" keyTimes="0;0.05;0.85;1" dur="0.9s" begin="0.6s" repeatCount="indefinite" />
      </circle>

      {/* ── Bottom sand — fills as top drains ─────────────────────────────── */}
      <g clipPath="url(#safe-hg-bot)">
        <polygon fill="#F3C300" opacity="0.9">
          <animate
            attributeName="points"
            values="
              31,43 33,43 33,44 31,44;
              17,58 47,58 60,76 4,76;
              5,44 59,44 60,76 4,76;
              5,44 59,44 60,76 4,76;
              31,43 33,43 33,44 31,44
            "
            keyTimes="0; 0.62; 0.76; 0.88; 1"
            dur="3s"
            repeatCount="indefinite"
          />
        </polygon>
      </g>
    </svg>
  );
}
